import React from "react";

const CenteredQuote = () => (
  <div className="flex items-center justify-center bg-black mt-32">
    <div className="text-center px-6 py-4">
      <p className="text-yellow-100 text-4xl font-bold leading-relaxed">
        "Track your weeks, stay motivated, and make every moment count with LockedIn – visualize your life at a glance."
      </p>
      {/* <p className="text-gray-400 text-2xl font-semibold italic mt-4">
        — Albert Schweitzer
      </p> */}
    </div>
  </div>
);

export default CenteredQuote;
